export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl overflow-hidden">
          <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-background-50/20 text-background-50 mb-4 whitespace-nowrap">
              移动观影
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-4">
              随时随地 · 掌上窝窝
            </h2>
            <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-6 max-w-[500px] mx-auto lg:mx-0">
              窝窝影院移动版全面适配手机与平板，支持高清播放在线不缓冲，流畅观看超清画质无广告。出门在外也能畅享海量高清电影电视剧，随时随地免费在线观看精彩内容。
            </p>
            <div className="flex flex-wrap items-center gap-3 justify-center lg:justify-start">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50 text-primary-700 font-semibold text-sm cursor-pointer whitespace-nowrap hover:bg-background-100 transition-colors">
                <i className="ri-android-line text-lg"></i>
                Android 版
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50/15 text-background-50 font-semibold text-sm border border-background-50/30 cursor-pointer whitespace-nowrap hover:bg-background-50/25 transition-colors">
                <i className="ri-apple-line text-lg"></i>
                iOS 版
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50/15 text-background-50 font-semibold text-sm border border-background-50/30 cursor-pointer whitespace-nowrap hover:bg-background-50/25 transition-colors">
                <i className="ri-global-line text-lg"></i>
                网页版
              </span>
            </div>
          </div>
          <div className="flex-1 flex justify-center lg:justify-end p-6 md:p-0">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20cinema%20streaming%20app%20interface%20with%20movie%20posters%20on%20screen%2C%20minimalist%20device%20mockup%20on%20clean%20white%20background%2C%20soft%20warm%20lighting%2C%20elegant%20product%20photography%2C%20professional%20app%20showcase%20with%20cinematic%20theme&width=600&height=800&seq=app-mobile-01&orientation=portrait"
              alt="窝窝影院移动端观影"
              className="w-auto h-[340px] md:h-[400px] object-contain"
              title="窝窝影院移动版"
            />
          </div>
        </div>
      </div>
    </section>
  );
}